<template>
  <div class="html">
    <div class="body">
      <!--            <a href="http://ccxqjy.ccxq.gov.cn/checkSite" target="_blank"><div class="img_box" v-show="linkShow"><span @click="closeLink"></span></div></a>-->
      <div id="header">
        <div class="box1">
          <div class="box2">
            <p class="Chinese">长春新区招生入学管理平台</p>
            <p class="English">
              CHANG CHUN XIN QU ZHAO SHENG RU XUE GUAN LI PING TAI
            </p>
          </div>
        </div>
      </div>
      <div id="content">
        <div class="box3">
          <ul class="ul1">
            <li class="special"><span>首页</span></li>
            <li>
              <a @click="jump('district', 'distRecruitStudents')"
                ><span>招生政策</span></a
              >
            </li>
            <li>
              <a @click="jump('district', 'distDegree')"
                ><span>学位占用查询</span></a
              >
            </li>
            <li>
              <a href="http://www.ccxq.gov.cn/ztzl/xqcx"
                ><span>学区查询</span></a
              >
            </li>
            <li id="li" @mouseleave="show = false" @mousemove="show = true">
              <span>学位预警</span>
              <ul id="ul2" :class="show == false ? '' : 'dis'">
                <a @click="jump('district', 'distWarningInfo')">
                  <li>学位预警信息</li>
                </a>
                <a @click="jump('district', 'waringMap')">
                  <li>预警地图</li>
                </a>
              </ul>
            </li>
            <li>
              <a @click="jump('district', 'distTransfer')"
                ><span>转学申请</span></a
              >
            </li>
            <li>
              <a @click="jump('district', 'distGuide')"
                ><span>办事指南</span></a
              >
            </li>
          </ul>
        </div>
        <!--轮播图开始-->
        <div class="box4">
          <ul class="btn1">
            <a @click="jump('district', 'distRecruitStudents')">
              <li></li>
            </a>
            <a @click="jump('district', 'distDegree')">
              <li></li>
            </a>
            <a href="http://www.ccxq.gov.cn/ztzl/xqcx">
              <li></li>
            </a>
          </ul>
          <ul class="btn2">
            <a @click="jump('district', 'waringmap')">
              <li></li>
            </a>
            <a @click="jump('district', 'distTransfer')">
              <li></li>
            </a>
            <a @click="jump('district', 'distGuide')">
              <li></li>
            </a>
          </ul>
        </div>
      </div>
    </div>

    <!--尾部-->
    <div class="interlayer"></div>
    <foot></foot>
    <!-- <div id="footer">
      <div class="footer-bottom">
        <div class="box7">
          <p>
            <img
              src="../../assets/eduDefault/icon.png"
            />备案号：吉ICP备20000186号-1&nbsp;联系我们：0431-80606821&nbsp;技术支持：卓越科技
          </p>
          <p>
            Copyright&nbsp;©&nbsp;2018-2023. All Rights
            Reserved.&nbsp;长春新区管理委员会&nbsp;版权所有
          </p>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { infoList } from "@/modules/index/api";
import { districts } from "@/modules/district/api";
import { mapActions, mapState } from "@/modules/district/views/state";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import foot from "@/components/foot.vue";

export default {
  name: "city-home",
  data() {
    return {
      districts: [],
      admissions: [],
      notice: [],
      warn: [],
      trends: [],
      showcheckeddetailelement: false,
      show: false,
      linkShow: true,
    };
  },
  components: {
    swiper,
    swiperSlide,
    foot,
  },
  computed: {
    ...mapState(["districtName", "currentPage"]),
    // 这里计算数据的长度，以此来判断是否显示，这个貌似要必写
    showSwiper() {
      return this.banner.length;
    },
  },
  created() {
    this.loadBaseData();
  },
  methods: {
    // go(path, orgId, name, action) {//TODO
    //     if (action == "distSchDistrict") {
    //         // if(orgId==220104){
    //         //     window.location.href="http://www.cczhcy.com/payment/education-district"
    //         // }else if(orgId==220177){
    //         //     window.location.href="http://ccxq.gov.cn/xueqvchaxun.aspx"
    //         //
    //         // }else{
    //         //     this.$site.setOrg(orgId)
    //         //     this.$site.setName(name)
    //         //     window.location.href = "/" + path + "/#/" + action
    //         // }
    //         window.location.href = "http://ccxq.gov.cn/xueqvchaxun.aspx"
    //     } else {
    //         this.$site.setOrg(orgId)
    //         this.$site.setName(name)
    //         window.location.href = "/" + path + "/#/" + action
    //     }
    // },
    async loadBaseData() {
      let res = await districts();
      this.districts = res.data;
    },

    delHtmlTag(str) {
      return str.replace(/<[^>]+>/g, "");
    },

    // jumpt(path, orgId, name, action) {
    //     this.$site.setOrg(orgId)
    //     this.$site.setName(name)
    //
    //     window.location.href = "/#/" + path  +"/"+  action
    // },

    jump(path, action) {
      // debugger
      // console.log(action)
      this.$site.setOrg(220177);
      this.$site.setName("长春市");
      window.location.href = "/" + path + "/#/" + action;
    },
    //
    // jjump(path, action, id) {
    //     this.$site.setId(id)
    //     this.$site.setOrg(220177)
    //     this.$site.setName("长春市")
    //     window.location.href = "/" + path + "/#/" + action
    //
    // },
    closeLink() {
      this.linkShow = false;
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}
.html {
  width: 100%;
  height: auto;
  min-height: 100%;
  position: relative;
  overflow-x: hidden;
  overflow: hidden;
}

.body {
  width: 100%;
  height: auto;
  position: relative;
}
.body .img_box {
  width: 400px;
  height: 130px;
  position: absolute;
  right: 0px;
  top: 50px;
  z-index: 999;
  /*background:url('../../assets/eduDefault/link.png') no-repeat;*/
  background-size: 100%;
  animation: move 50s linear 0s infinite alternate;
}
.body .img_box:hover {
  animation-play-state: paused;
}
@keyframes move {
  0% {
    right: 0%;
    top: 0%;
  }
  10% {
    right: 10%;
    top: 25%;
  }
  20% {
    right: 20%;
    top: 45%;
  }
  30% {
    right: 30%;
    top: 65%;
  }
  40% {
    right: 40%;
    top: 90%;
  }
  50% {
    right: 55%;
    top: 75%;
  }
  60% {
    right: 70%;
    top: 60%;
  }
  70% {
    right: 80%;
    top: 45%;
  }
  80% {
    right: 55%;
    top: 30%;
  }
  90% {
    right: 25%;
    top: 15%;
  }
  100% {
    right: 0%;
    top: 0%;
  }
}
.body .img_box span {
  display: block;
  width: 30px;
  height: 30px;
  cursor: pointer;
  position: absolute;
  right: 0px;
  top: 0px;
}
.body .img_box img {
  width: 400px;
  height: 130px;
}
#header {
  width: 100%;
  height: 239px;
  background: url("../../assets/eduDefault/bg.png") no-repeat;
  background-size: cover;
  position: relative;
}
.box1 {
  width: 668.16px;
  height: 84.96px;
  position: absolute;
  top: 60px;
  cursor: pointer;
}
.box2 {
  width: 583.2px;
  height: auto;
  position: absolute;
  right: 0;
  top: 0;
}
.Chinese {
  font-family: PingFangSC-Semibold;
  font-size: 43.2px;
  color: #3d3d3d;
  letter-spacing: 2px;
  font-weight: bold;
}
.English {
  font-family: PingFang-SC-Semibold;
  font-size: 14px;
  color: #494949;
  letter-spacing: 2px;
  line-height: 36px;
}

.box3 {
  width: 100%;
  height: auto;
  background: #ffffff;
  box-shadow: 0 9px 10px 5px rgba(224, 224, 224, 0.5);
}
.box3 .ul1 {
  width: 1148px;
  height: 54px;
  margin: 0 auto;
}

.box3 .ul1 li {
  width: 164px;
  height: 100%;
  line-height: 54px;
  float: left;
  text-align: center;
  cursor: pointer;
  font-size: 15.6px;
  font-family: PingFangSC-Regular;
  color: #000000;
  letter-spacing: -0.66px;
}
.box3 .ul1 li a {
  color: #000;
  display: block;
}
.box3 .ul1 li:hover a {
  color: #fff;
}

.box3 .ul1 li:hover {
  background: #abe000;
  color: #fff;
}

.box3 .ul1 .special {
  background: #abe000;
  color: #fff;
}

#li {
  position: relative;
}
#ul2 {
  display: none;
  position: absolute;
  z-index: 999;
}
#ul2 a li {
  background: #fff;
  box-shadow: 0 9px 10px 5px rgba(224, 224, 224, 0.5);
}
#ul2 a:hover li {
  background: #abe000;
  color: #fff;
}

.box4 {
  width: 1130px;
  height: 400px;
  margin: 60px auto;
  /*margin-top:110px;*/
}

.box4 ul {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
}

.box4 ul li {
  width: 240px;
  height: 192px;
  cursor: pointer;
}

.btn1 a:nth-child(1) {
  background: url("../../assets/eduDefault/btn1.png") no-repeat;
  background-size: 100%;
}

.btn1 a:nth-child(2) {
  background: url("../../assets/eduDefault/btn2.png") no-repeat;
  background-size: 100%;
}

.btn1 a:nth-child(3) {
  background: url("../../assets/eduDefault/btn3.png") no-repeat;
  background-size: 100%;
}

.btn2 {
  margin-top: 44px;
}

.btn2 a:nth-child(1) {
  background: url("../../assets/eduDefault/btn4.png") no-repeat;
  background-size: 100%;
}

.btn2 a:nth-child(2) {
  background: url("../../assets/eduDefault/btn5.png") no-repeat;
  background-size: 100%;
}

.btn2 a:nth-child(3) {
  background: url("../../assets/eduDefault/btn6.png") no-repeat;
  background-size: 100%;
}

.interlayer {
  width: 100%;
  height: 10px;
  background: #abe000;
}

#footer {
  width: 100%;
  height: auto;
  background-image: linear-gradient(180deg, #2a76e6 0%, #5ab6ff 100%);
}

.link .ul4 a {
  color: #fff;
  font-size: 16px;
  text-decoration: none;
  line-height: 42px;
}

#footer .footer-bottom {
  width: 100%;
  height: 108.8px;
  background: #fff;
}

#footer .footer-bottom .box7 {
  color: #5f6464;
  font-size: 16px;
  position: relative;
  top: 24.4px;
  letter-spacing: 0.5px;
}

#footer .footer-bottom .box7 p {
  line-height: 30px;
  text-align: center;
}
#footer .footer-bottom .box7 p:nth-child(3) {
  margin-left: -9px;
}

#footer .footer-bottom .box7 img {
  width: 20px;
  height: 20px;
  position: relative;
  left: 0px;
  top: 3px;
  margin-right: 5px;
}

.dis {
  display: block !important;
}
</style>
